import { useContext, useEffect } from 'react';
import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import FooterSection from '../footer';
import MasterActionsPlayersComponent from '../layout/master-actions-players';
import TeamNavigationComponent from '../TeamNavigationComponent';
import Navigation from '../navigation/Navigation';
import SecondaryNavigationLayout from '../layouts/SecondaryNavigationLayout';
import DrawerMenuComponent from '../navigation/DrawerMenu/DrawerMenuComponent';
import useThemeManager from '@/DesignSystem/hooks/useThemeManager';
import useDrawerState from '@/DesignSystem/hooks/useDrawerState';
import { NotificationInitializer, NotificationProvider } from '@/notifications/notify';
//import useAdPushOnRoute from '@/DesignSystem/hooks/useAdPushOnRoute';
import TopAd from './TopAd';
import GoogleOneTapPrompt from './GoogleOneTapPrompt';
import LeftFixedAd from './LeftFixedAd';
import RightFixedAd from './RightFixedAd';
import BottomFixedAd from './BottomFixedAd';
import useIsBettingSection from '@/DesignSystem/hooks/useIsBettingSection';

const MainLayout = ({ children }) => {
    const { state, dispatch } = useContext(Context);
    const { leftDrawer, handleCloseLeftDrawer, handleHamburguerMenu } = useDrawerState();
    const isBettingSection = useIsBettingSection();

    const currentTheme = useThemeManager(state.theme, dispatch);

    //useAdPushOnRoute();

    useEffect(() => {
        dispatch({ type: REDUCERS.GET_DATA_FROM_COOKIES });

        const preferences = JSON.parse(localStorage.getItem('af--preferences'));
        if (preferences) {
            dispatch({ type: REDUCERS.UPDATE_PREFERENCES, payload: preferences });
        }
    }, []);

    return (
        <ThemeProvider theme={currentTheme}>
            <Box sx={{ position: 'relative' }}>
                <NotificationProvider>
                    <NotificationInitializer />
                    <GoogleOneTapPrompt user={state.user} dispatch={dispatch} />
                    <Navigation handleHamburguerMenu={handleHamburguerMenu} />
                    <TeamNavigationComponent />

                    <DrawerMenuComponent
                        anchor="left"
                        open={leftDrawer}
                        handleClose={handleCloseLeftDrawer}
                    />

                    <SecondaryNavigationLayout isBettingSection={isBettingSection}>
                        {!isBettingSection && (
                            <>
                                <TopAd />
                                <LeftFixedAd />
                                <RightFixedAd />
                            </>
                        )}
                        {children}
                    </SecondaryNavigationLayout>

                    <FooterSection />

                    <MasterActionsPlayersComponent />
                </NotificationProvider>
                <Box id="ads-scripts"></Box>
                {!isBettingSection && <BottomFixedAd />}
            </Box>
        </ThemeProvider>
    );
};

export default MainLayout;
